import { Box, Button, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import PageHeader from 'layout/pageHeader';
import { useTranslation } from 'helpers/languages/translations';
import ColorManagementTab from 'pages/Preferences/components/molecules/ColorsTab';
import GlobalCategoriesTab from 'pages/Preferences/components/molecules/GlobalCategoriesTab';
import { useTabNavigate } from 'router/tabsMapper';
import { useGetAuthorizedTabsSelector } from 'core/redux/selectors/authSelectors';
import { ArrowUpIcon } from '@chakra-ui/icons';

const PATH = 'preferences';
const ID = 'cdm_preferences';
const NAME = 'page.preferences';

const ColorManagement = () => {
    const { authorizedTabs } = useGetAuthorizedTabsSelector();
    const navigate = useNavigate();
    const displayColorsTab = authorizedTabs.includes('cdm_colors');
    const displayGlobalCategoriesTab = authorizedTabs.includes('cdm_global_categories');
    const { tabIndex, setTabIndex } = useTabNavigate('preferences', {
        colors: displayColorsTab,
        'global-categories': displayGlobalCategoriesTab,
    });
    const translate = useTranslation();


    const renderTabs = () => (
        <Tabs size="sm" onChange={(index) => setTabIndex(index)} index={tabIndex} isLazy>
            <TabList>
                {displayColorsTab && <Tab _focus={{ boxshadow: 'none' }}>{translate('tab.colors')}</Tab>}
                {displayGlobalCategoriesTab && (
                    <Tab _focus={{ boxshadow: 'none' }}>{translate('tab.globalCategories')}</Tab>
                )}
            </TabList>

            <TabPanels>
                {displayColorsTab && (
                    <TabPanel px="0">
                        <ColorManagementTab />
                    </TabPanel>
                )}

                {displayGlobalCategoriesTab && (
                    <TabPanel px="0">
                        <GlobalCategoriesTab />
                    </TabPanel>
                )}
            </TabPanels>
        </Tabs>
    );

    return (
        <Box>
            <PageHeader icon={{ name: 'preferences' }} pageTitle={translate(NAME) as string}>
                {tabIndex === 1 && (
                    <Button
                        onClick={() => navigate('upload')}
                        fontSize="14px"
                        h="30px"
                        bg={'white'}
                        variant="outline"
                        leftIcon={<ArrowUpIcon />}
                    >
                        {translate('file.upload')}
                    </Button>
                )}
            </PageHeader>
            <Box px="32px">{renderTabs()}</Box>
        </Box>
    );
};

export { ID, PATH, NAME };
export default ColorManagement;
